import Listener from '../../core/watcher/Listener'
import EventEmitterManager from '../../core/event/EventEmitterManager'
import ClassSwitcherElement from '../../core/element/ClassSwitcherElement'
import VisibilitySwitcherElement from '../../core/element/VisibilitySwitcherElement'
import './_style.scss'

Listener.onLoadDOM(() => {

   if (window.innerWidth < 1140) {
      const headerImg = new VisibilitySwitcherElement(document.querySelector('.header__img'))
      const visibilitySwitcher = new ClassSwitcherElement(document.getElementById('menu'), 'menu--opened')

      Listener.onClickSelector('#mobile-open-menu', () => {
         document.body.style.overflowY = 'hidden'
         visibilitySwitcher.addClass()
         headerImg.show()
      })
      Listener.onClickSelector('#mobile-close-menu', () => {
         document.body.style.overflowY = 'scroll'
         visibilitySwitcher.removeClass()
         headerImg.hide()
      })

      Listener.onClickAll('.dropdown-toggle', event => {
         event.preventDefault()
         event.target.classList.toggle('dropdown-toggle--opened')
      })

       const openMenuElement = new ClassSwitcherElement(document.getElementById('mobile-open-menu'), 'mobile-menu-button__open--top-150')
       EventEmitterManager.subscribeScrolledBelowOfferSlider(openMenuElement.addClass)
       EventEmitterManager.subscribeScrolledAboveOfferSlider(openMenuElement.removeClass)
       EventEmitterManager.subscribeScrolledBelowLookingFor(openMenuElement.addClass)
       EventEmitterManager.subscribeScrolledAboveLookingFor(openMenuElement.removeClass)
   }
})